export class UtilString {
    static convertToObjectPathArray(path, separator) {
        if (!path) {
            return '';
        }
        if (!separator) {
            separator = '/';
        }
        if (path.indexOf(separator) === 0) {
            path = path.substring(1);
        }
        return path.split(separator);
    }
    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    static arrayInString(strings, string) {
        let i = 0;
        let inString = false;
        do {
            inString = string.indexOf(strings[i++]) !== -1;
        } while (!inString && i < strings.length);
        return inString;
    }
    static convertToObjectPath(path, separator) {
        const result = this.convertToObjectPathArray(path, separator).join('.');
        return result;
    }
    static escapeSpecialChar(text) {
        const rexp = /[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi;
        return text.replace(rexp, '\\$&');
    }
}
